import { c as _c } from "react/compiler-runtime";
import type { FreezeOffMessage } from '@module/types/centrifuge/public-message/freezeMessageTypes';
interface Props {
  item: FreezeOffMessage;
}
export default function FreezeOffChat(props) {
  const $ = _c(2);
  const {
    item
  } = props;
  const {
    message
  } = item.data;
  const t0 = `${message.name}에 의해 채팅창이 허용되었습니다.`;
  let t1;
  if ($[0] !== t0) {
    t1 = <div className="mb-[3px] whitespace-pre-wrap text-cht_al_1"><div>{t0}</div></div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}